module.exports = __webpack_public_path__ + "img/listIcon.4af196c4.png";